export default __webpack_public_path__ + "images/DB.27b6cba.png";